// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';

import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../lib/segment/SegmentService';

import * as Authorization from '../../lib/authorization';
import Console from '../../lib/debug';
import { FEATURES } from '../../v5/features/components/constants';

type Props = {
    loggedInUser: object,
    features: {}
};
class UpgradeButton extends Component<Props> {
    redirectToBilling = () => {
        const { loggedInUser, features } = this.props;
        SegmentService.track(SEGMENT_EVENTS.UpgradeNowClicked.key, {
            userId: loggedInUser.id,
            currentSubscriptionPlan: loggedInUser.roles,
            daysLeftInTrial: loggedInUser.trial_days_remaining
        });

        if (features[FEATURES.COACH_PRICING]) {
            return (window.location =
                Authorization.navigateToSubscriptionPlans.path);
        }

        return (window.location =
            Authorization.navigateToLegacySubscriptionPlans.path);
    };

    render() {
        Console.render('UpgradeButton');

        const { loggedInUser, headCoach } = this.props;
        const isTrialOrBasic =
            headCoach && (loggedInUser.isTrial || loggedInUser.isBasic);

        if (!isTrialOrBasic) {
            return null;
        }
        let trialRemainingCopy = '';
        if (loggedInUser.trial_days_remaining <= 0) {
            trialRemainingCopy =
                'Trial expired! Upgrade to use TrainHeroic with your athletes.';
        } else if (loggedInUser.trial_days_remaining == 1) {
            trialRemainingCopy =
                'Trial expires today! Upgrade to continue using TrainHeroic with your athletes.';
        } else {
            const singularPlural =
                loggedInUser.trial_days_remaining == 1 ? '' : 's';
            trialRemainingCopy =
                loggedInUser.trial_days_remaining +
                ' day' +
                singularPlural +
                ' remaining in trial';
        }

        return (
            <div>
                <p className="upgrade-now-copy">
                    {trialRemainingCopy}
                    <br />Plans start at $9.99
                </p>
                <Button
                    onClick={this.redirectToBilling}
                    className="contained-button upgrade-now"
                >
                    Upgrade Now
                </Button>
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        loggedInUser: state.app.loggedInUser,
        features: state.features,
        headCoach: state.app.headCoach
    };
};

export default connect(mapStateToProps)(UpgradeButton);
